import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonNotificationObject } from '../types';
import { INotificationAttrs } from '../../AppComponents/Notifications/types';

interface IAddPeerNotificationsState extends Record<string, any> {
  notificationAttrs: INotificationAttrs;
  notification: CommonNotificationObject;
}

export const initialState: IAddPeerNotificationsState = {
  notification: {},
  notificationAttrs: {} as INotificationAttrs,
};

const addPeerNotificationsSlice = createSlice({
  name: 'addPeerNotifications',
  initialState,
  reducers: {
    changeAddPeerNotification(
      state,
      action: PayloadAction<CommonNotificationObject>,
    ) {
      state.notification = action.payload;

      if (Object.keys(state.notificationAttrs).length <= 0) {
        state.notificationAttrs = {
          mainLoad: 0,
          failed: false,
          fullyComplete: false,
        };
      }
    },
    changeAddPeerNotificationAttrs(
      state,
      action: PayloadAction<Record<keyof INotificationAttrs, any>>,
    ) {
      state.notificationAttrs = {
        ...state.notificationAttrs,
        ...action.payload,
      };
    },
    clearAddPeerNotifications() {
      return initialState;
    },
  },
});

export const {
  changeAddPeerNotification,
  clearAddPeerNotifications,
  changeAddPeerNotificationAttrs,
} = addPeerNotificationsSlice.actions;

export default addPeerNotificationsSlice.reducer;
